import * as accountRequestAPI from 'login-apis/accountRequestAPI';
import { SubmissionError } from 'redux-form';
import * as loginErrorMessageUtils from 'login-utils/loginErrorMessageUtils';

export async function submitPasswordReset(valuesToSubmit) {
  try {
    return await accountRequestAPI.submit('passwordReset', valuesToSubmit);
  } catch (err) {
    // Coming back from this can be either an error string (like "You cannot reuse a password")
    // or a code that needs to be run through the normalizer function.
    const errorResponse = err.response.data;
    const possibleMessage = loginErrorMessageUtils.generate(errorResponse);
    throw new SubmissionError({ _error: (possibleMessage && possibleMessage.message) || errorResponse });
  }
}
